import React from 'react'
import { 
    Switch, 
    Route, 
    Redirect
} from 'react-router-dom';
import { LoginPage } from '../auth/LoginPage';

export const AuthRouter = () => {
    return (
        <div style={{height: 'inherit'}}>
            <Switch>
                <Route
                    exact path="/auth/login" 
                    component={ LoginPage }
                />

                {/* <Route
                exact path="/auth/register" 
                component={ RegisterPage }
                /> */}
                <Redirect to="/auth/login" />
            </Switch>

        </div>
    )
};
